import { IConfig } from './interfaces/config';
import { IConfigMask } from './interfaces/config-mask';

export {
    IConfig,
    IConfigMask
};



// WEBPACK FOOTER //
// ./src/app/shared/directives/jquery-date-picker/jquery-date-picker.directive.interface.ts